/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PresetItemResponse {
  id: string;
  name: string;
  canonical_id?: string | null;
  domain?: string | null;
  sort_order?: number;
}
